
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConfig {
    IsPortal = false
    ViewOfficesLinkSrc = 'https://view.officeapps.live.com/op/embed.aspx?src='
    covidUserGuide = 'https://emed.un.org/resources/doc/EarthMed User Guide - Covid-19 v2020-10-29.pdf'
    DrugScreeningUserGuide = 'https://emed.un.org/resources/doc/Drug Screening in EarthMed 20230115.pdf'

    CADocumentURL = 'https://emed.un.org/resources/doc/ConfidentialityAgreement.pdf'
    CADocumentURLPortal = 'https://medical.un.org/resources/doc/ConfidentialityAgreement.pdf'

    SCOCADocumentURL = 'https://emed.un.org/resources/doc/Confidentiality Guidelines for UNSSCG.pdf'
    SCOCADocumentURLPortal = 'https://medical.un.org/resources/doc/Confidentiality Guidelines for UNSSCG.pdf'

    CovidVaccinationForTravelURL = 'https://emed.un.org/resources/doc/COVID Vaccination for Travel Clearance.pdf'
    CovidVaccinationForTravelURLPortal = 'https://medical.un.org/resources/doc/COVID Vaccination for Travel Clearance.pdf'

    UNMemoCADocumentURL = 'https://emed.un.org/resources/doc/UNMemo Confidentiality agreements.pdf'
    UNMemoCADocumentURLPortal = 'https://medical.un.org/resources/doc/UNMemo Confidentiality agreements.pdf'

    SCOUNMemoCADocumentURL = 'https://emed.un.org/resources/doc/UNMemo Confidentiality agreements Counsellors.pdf'
    SCOUNMemoCADocumentURLPortal = 'https://medical.un.org/resources/doc/UNMemo Confidentiality agreements Counsellors.pdf'

    UNMemoAuditingDocumentURL = 'https://emed.un.org/resources/doc/UNMemo Auditing SPA.pdf'
    UNMemoAuditingDocumentURLPortal = 'https://medical.un.org/resources/doc/UNMemo Auditing SPA.pdf'

    BloodGroupRequestURL = 'https://emed.un.org/resources/doc/Blood group requests.pdf'
    BloodGroupRequestURLPortal = 'https://medical.un.org/resources/doc/Blood group requests.pdf'

    TravelClearanceRoutingURLPortal = 'https://medical.un.org/resources/attachments/travel/Travel Clearance Routing.pdf'

    ContactUsPage = 'https://emed.un.org/support/earthmed/contactus'
    PortalContactUsPage = 'https://medical.un.org/support/EarthMed/ContactUs'
    CaseMergeVideo = 'https://emed.un.org/resources/attachments/cases/How_to_merge_cases_20190716.mp4'
    ATCPGuideVideo = 'https://emed.un.org/resources/attachments/travel/ATCPGuideline.mp4'
    ImmuniationUserGuide = 'https://emed.un.org/resources/doc/EarthMed User Guide - Immunizations v20210427.pdf'

    EarthMedUserAccountManagementGuideURL = 'https://emed.un.org/resources/doc/EarthMed User Account Management.pdf'

    EarthMedUserAccountManagementVideo = 'https://emed.un.org/resources/attachments/accounts/Introduction and Training on User Management in EarthMed-20220825_080317-Meeting Recording.mp4'

    HoSReport = 'https://emed.un.org/resources/attachments/accounts/Hos report 20230101.xls'

    ConfidentialitySOPURL = 'https://emed.un.org/resources/doc/Confidentiality SOP 230811 FS_Signed by USG.pdf'
    ConfidentialitySOPURLPortal = 'https://medical.un.org/resources/doc/Confidentiality SOP 230811 FS_Signed by USG.pdf'
    ConfidentialityUndertakingURL = 'https://emed.un.org/resources/doc/DHMOSH-DOS Medical Confidentiality Undertaking (2026).pdf'


    MD9URL = 'https://emed.un.org/resources/doc/MD9 Confidentiality plus SOP.pdf'
    MD9URLPortal = 'https://medical.un.org/resources/doc/MD9 Confidentiality plus SOP.pdf'

    MD10URL = 'https://emed.un.org/resources/doc/MD10 User User records access 20231115.pdf'
    MD10URLPortal = 'https://medical.un.org/resources/doc/MD10 User User records access 20231115.pdf'

    UserRecordAccessURL = 'https://emed.un.org/resources/doc/User-User  record access notification 231115.pdf'
    UserRecordAccessURLPortal = 'https://medical.un.org/resources/doc/User-User  record access notification 231115.pdf'

    EMUAMUserGuide = 'https://emed.un.org/resources/doc/EMUAM user guide.pdf'

    RegionalDelegationOfMedicalEntitlements = 'https://emed.un.org/resources/doc/Regional Delegation of Medical Entitlements for Duty Stations Without a UN Clinic or DPPA_DPO Mission SOP (2 Sep 2025).pdf'


}
